// extracted by mini-css-extract-plugin
module.exports = {"prNavigation":"styles_prNavigation__1ea49","prNavigation__content":"styles_prNavigation__content__2BZeW"};